import posthog from 'posthog-js';
import { resetSessionAnalytics } from './sessionAnalytics';

const safely = (callback) => {
  try {
    callback();
  } catch {
    // Session invalidation must continue even when browser storage or telemetry is unavailable.
  }
};

const redirectToLogin = (dispatch, error) => {
  safely(() => dispatch?.({ type: 'INVALID' }));

  const forceRefresh = error?.response?.data?.force || false;
  safely(() => localStorage.setItem(
    'm8_error',
    forceRefresh
      ? 'Your session has expired. Please login again to continue'
      : 'Invalid username or password',
  ));

  if (process.env.NODE_ENV !== 'development' && posthog) {
    safely(() => posthog.reset());
  }
  resetSessionAnalytics();
  safely(() => window.location.reload());
};

export default redirectToLogin;
